import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/core/services/utils.service';

@Component({
  selector: 'app-select-page',
  templateUrl: './select-page.component.html',
  styleUrls: ['./select-page.component.scss'],
})
export class SelectPageComponent implements OnInit {
  id_evento = null;
  tipo_evento = null;
  public data_for_url = {};

  constructor(private svUtils: UtilsService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.id_evento = this.route.snapshot.paramMap.get('id_evento');
    this.tipo_evento = this.route.snapshot.paramMap.get('tipo_evento');
  }

  goToPortal(portal) {
    let empresa = JSON.parse(localStorage.getItem('empresa'));

    let nombre_id_tipo = '';
    if (this.tipo_evento == 'marketplace') {
      nombre_id_tipo = 'id_marketplace';
    }

    if (this.tipo_evento == 'feria') {
      nombre_id_tipo = 'id_feria';
    }

    this.data_for_url = {
      id_empresa_usuario: empresa.id_empresa_usuario,
      token: this.svUtils.getAt(),
    };
    this.data_for_url[nombre_id_tipo] = this.id_evento;
    this.data_for_url = btoa(JSON.stringify(this.data_for_url));
    let url = `${empresa.subdominio_empresa_usuario}/${portal}/?`;
    if (portal == 'marketplace') {
      url = `https://eventvr.infoverses.com/marketplace/personalizacion/?`;
    }

    window.open(`${url}ed=${this.data_for_url}`, '_blank');
  }
}
